import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon } from 'lucide-react';
import { compras } from '../data/compras';
const SHOW_EVERY_MS = 15000;
const VISIBLE_MS = 6000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimeout: number;
    const cycle = () => {
      setVisible(true);
      hideTimeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % compras.length);
      }, VISIBLE_MS);
    };
    const firstTimeout = window.setTimeout(cycle, 5000);
    const interval = window.setInterval(cycle, SHOW_EVERY_MS);
    return () => {
      window.clearTimeout(firstTimeout);
      window.clearTimeout(hideTimeout);
      window.clearInterval(interval);
    };
  }, []);
  const compra = compras[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-3 z-50 max-w-[calc(100vw-1.5rem)] sm:bottom-6 sm:left-4" data-id="element-201" data-mp="1gynft8kxm4hr">
      <AnimatePresence data-id="element-202" data-mp="117fr24c0fxse">
        {visible ? <motion.a key={`${compra.name}-${index}`} href="#plan-sistema-total" initial={{
        opacity: 0,
        x: -16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -16,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="popup-dorado pointer-events-auto flex max-w-[300px] items-start gap-3 rounded-2xl border-2 border-gold-400 bg-white px-4 py-3 shadow-lift transition-transform duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2" data-id="element-203" data-mp="116cylrz1hnad">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-celeste-600" aria-hidden="true" data-id="element-204" data-mp="28j4z2hjmu61y" />
            <div data-id="element-205" data-mp="23npru8g4r8ei">
              <p className="font-display text-sm font-bold leading-tight text-ink-900" data-id="element-206" data-mp="2aotgq36xhdde">
                {compra.name} acaba de comprar
              </p>
              <p className="mt-1 text-[13px] leading-snug text-ink-700" data-id="element-207" data-mp="2fltfdt1g7duh">
                {compra.product}
              </p>
              <p className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-ink-400" data-id="element-208" data-mp="2kkwhp5q1n5yr">
                <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-209" data-mp="1ryv0gzsz8dyo" />
                {compra.city}
              </p>
            </div>
          </motion.a> : null}
      </AnimatePresence>
    </div>;
}